import React, { useEffect } from 'react';
import { Button, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SalesInvoiceRegisterForm from '../components/SalesInvoiceRegisterForm';
import { useGetSalesInvoiceRegisterHandler } from '../dataHandlers/getSalesInvoiceRegisterHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { UPDATE_SALE_REGISTER } from '../../../constants/eInvoicePermissions';

export default function SalesInvoiceRegisterDetailsPage() {
  const { salesInvoiceRegister } = useTranslatedMessages();
  useDocumentTitle(salesInvoiceRegister?.pages?.details_title ?? 'Sales Invoice Register Details');
  const navigate = useNavigate();
  const { document_id } = useParams();
  const { register, isLoading } = useGetSalesInvoiceRegisterHandler(document_id);
  const { hasEInvoicePermission } = usePermissions();
  const canUpdate = hasEInvoicePermission(UPDATE_SALE_REGISTER);

  useEffect(() => {
    if (!isLoading && register?.document_mode === 'E_INVOICE') {
      const documentId = register.uuid || register.id;
      navigate(`/sales/documents/invoices/${documentId}`, { replace: true });
    }
  }, [isLoading, register, navigate]);

  if (isLoading || !register) {
    return <DocumentSkeletonForm />;
  }

  if (register.document_mode === 'E_INVOICE') {
    return <DocumentSkeletonForm />;
  }

  const onClickingBackButton = () => navigate('/sales-invoice-register');

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <SalesInvoiceRegisterForm onSubmit={() => {}} onCancel={onClickingBackButton} initialData={register} readOnly />
    </Stack>
  );
}
